<!--
 * @Descripttion: 操作按钮弹窗
 * @Author: zenghua.wang
 * @Date: 2021-08-04 17:11:00
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-04 13:58:15
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    width="60%"
  >
    <el-form
      ref="btnForm"
      :model="form"
      :rules="rules"
      size="small"
      @submit.native.prevent
      label-width="140px"
      label-suffix="："
    >
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="按钮名称"
            prop="name"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="form.name"
              style="width:100%;"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="按钮类型"
            prop="position"
          >
            <el-select
              v-model="form.position"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                v-for="(item,index) in options.positionList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="按钮标识"
            prop="tag"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="form.tag"
              style="width:100%;"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="PC样式"
            prop="style"
          >
            <el-select
              v-model="form.style"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                v-for="(item,index) in options.styleList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="按钮icon">
            <el-input
              placeholder="请输入"
              clearable
              v-model="form.icon"
              style="width:100%;"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="click事件"
            prop="fun"
          >
            <el-select
              v-model="form.fun"
              clearable
              placeholder="请选择"
              style="width:100%;"
              @change="setMethod"
            >
              <el-option
                v-for="(item,index) in options.funList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="显示设备">
            <el-radio-group
              v-model="form.device"
              size="small"
            >
              <el-radio label="desktop">PC</el-radio>
              <el-radio label="mobile">Mobile</el-radio>
              <el-radio label="">两端显示</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col
          :span="12"
          v-if="form.position==='row'"
        >
          <el-form-item label="Mobile按钮位置">
            <el-select
              v-model="form.direction"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                label="right"
                value="right"
              ></el-option>
              <el-option
                label="bottom"
                value="bottom"
              ></el-option>
            </el-select>
            <div class="xa-form-tips">备注：多个按钮推荐默认bottom显示，单个按钮推荐right显示</div>
          </el-form-item>
        </el-col>

        <el-col
          :span="24"
          v-if="form.position==='row'"
        >
          <el-form-item label="显示条件表达式">
            <el-input
              type="textarea"
              placeholder="如：${name} && ${name}==='张三' || ${state} ===1"
              clearable
              v-model="form.condition"
              style="width:100%;"
            ></el-input>
            <div class="xa-form-tips">备注：按钮默认显示，若有表达式，以表达式判断为准、变量用${var}代替，仅对行内按钮有效！</div>
          </el-form-item>
        </el-col>

        <!-- openURL -->
        <template v-if="form.fun==='openURL'">
          <el-col :span="24">
            <el-form-item label="窗口地址">
              <el-input
                type="textarea"
                placeholder="如：http://www.wiseloong.com?id=${id}&processCode=${main.processCode}"
                clearable
                v-model="form.url"
                style="width:100%;"
              ></el-input>
              <div class="xa-form-tips">备注：参数uuid配置格式为 xx=${uuid}&xxx=${uuid32}</div>
            </el-form-item>
          </el-col>
        </template>

        <!-- event and formatter-->
        <el-col
          :span="12"
          v-if="form.fun==='event'"
        >
          <el-form-item label="自定义事件">
            <el-button
              type="primary"
              @click="showFormatter=true"
            >设置</el-button>
          </el-form-item>

          <common-formatter
            :show.sync="showFormatter"
            :formatter="form.formatter"
            :placeholder="placeholder"
            @change="updateFormatter"
          />
        </el-col>

        <!-- dialog -->
        <template v-if="form.fun==='dialog'">
          <el-col :span="24">
            <el-form-item label="iframe地址">
              <el-input
                type="textarea"
                placeholder="请输入"
                clearable
                v-model="form.url"
                style="width:100%;"
              ></el-input>
              <div class="xa-form-tips">备注：参数uuid配置格式为 xx=${uuid}&xxx=${uuid32}</div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="弹框标题">
              <el-input
                placeholder="请输入"
                clearable
                v-model="form.title"
                style="width:100%;"
              ></el-input>
              <div class="xa-form-tips">备注：弹框标题支持文字输入和变量(${var})，变量仅对行内按钮有效！</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="弹框宽度">
              <el-input
                placeholder="请输入"
                clearable
                v-model="form.width"
                style="width:100%;"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="弹框高度">
              <el-input
                placeholder="请输入"
                clearable
                v-model="form.height"
                style="width:100%;"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否全屏">
              <el-select
                v-model="form.fullscreen"
                clearable
                placeholder="请选择"
                style="width:100%;"
              >
                <el-option
                  label="是"
                  value="是"
                ></el-option>
                <el-option
                  label="否"
                  value="否"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>

        <!-- interface/import/export -->
        <template v-if="apisButton.includes(form.fun)">
          <el-col :span="24">
            <el-form-item label="接口地址">
              <el-input
                placeholder="请输入"
                clearable
                v-model="form.url"
                style="width:100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请求方式">
              <el-select
                v-if="apisMethod.includes(form.fun)"
                style="width:100%"
                size="small"
                clearable
                placeholder="请选择"
                v-model="form.reqMethod"
              >
                <el-option
                  v-for="(item,index) in options.methodList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-select
                v-if="form.fun ==='import'"
                style="width:100%"
                size="small"
                clearable
                placeholder="请选择"
                v-model="form.reqMethod"
              >
                <el-option
                  label="POST"
                  value="POST"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请求参数">
              <el-button
                icon="el-icon-plus"
                type="primary"
                size="small"
                style="margin-bottom: 20px"
                @click="addParams"
              >新增</el-button>
              <el-table
                size="small"
                tooltip-effect="dark"
                style="width:100%;"
                border
                fit
                :data="form.params"
              >
                <el-table-column
                  label="参数名"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      clearable
                      placeholder="请输入"
                      v-model="scope.row.label"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="参数值 (备注:参数值可为默认值，或者字段;如:id)"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      clearable
                      placeholder="请输入"
                      v-model="scope.row.value"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="参数类型"
                  align="center"
                  width="160"
                >
                  <template slot-scope="scope">
                    <el-select
                      style="100%"
                      size="small"
                      clearable
                      placeholder="请选择"
                      v-model="scope.row.type"
                    >
                      <el-option
                        label="query"
                        value="query"
                      ></el-option>
                      <el-option
                        label="body"
                        value="body"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作"
                  width="80"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteParams(scope.$index)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-if="form.fun==='export'"
                class="xa-form-tips"
                style="padding-top:10px"
              >注意：<span style="color:#3b9cd9;">数据导出</span> 提供了一个默认接口，接口地址：/apis/exportExcel/apis-xxx, 请求方式：POST, 请求参数: {fileName: 列表标题/报表名称，doDownload：true}<br />
                若使用默认接口，默认配置禁止修改，若自定义数据导出接口，请进行修改配置；
              </div>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-if="form.fun==='interface'"
          >
            <el-form-item label="提示语">
              <el-input
                type="textarea"
                placeholder="请输入"
                clearable
                v-model="form.tips"
                style="width:100%;"
              ></el-input>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-circle-check"
        @click="onSubmit"
      >保 存</el-button>
      <el-button
        size="small"
        @click="visible = false"
        icon="el-icon-circle-close"
      >取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { deepClone } from '@/dragComponents/utils'

import commonFormatter from '@/dragComponents/config/common/formatter.vue'

export default {
  name: 'report-button',
  inject: ['main'],
  components: {
    commonFormatter
  },
  props: {
    title: {
      type: String,
      default: '新增'
    },
    show: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    row: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      apisButton: ['interface', 'import', 'export'],
      apisMethod: ['interface', 'export'],
      form: {},
      options: {
        positionList: [
          {
            label: '表头',
            value: 'header'
          },
          {
            label: '行内',
            value: 'row'
          }
        ],
        styleList: [
          {
            label: '文字按钮',
            value: 'text'
          },
          {
            label: '主要按钮',
            value: 'primary'
          },
          {
            label: '成功按钮',
            value: 'success'
          },
          {
            label: '信息按钮',
            value: 'info'
          },
          {
            label: '警告按钮',
            value: 'warning'
          },
          {
            label: '危险按钮',
            value: 'danger'
          }
        ],
        funList: [
          {
            label: '新窗口打开',
            value: 'openURL'
          },
          {
            label: '弹窗窗口',
            value: 'dialog'
          },
          {
            label: 'apis接口',
            value: 'interface'
          },
          {
            label: '数据导入',
            value: 'import'
          },
          {
            label: '数据导出',
            value: 'export'
          },
          {
            label: '自定义事件',
            value: 'event'
          }
        ],
        methodList: [
          {
            label: 'GET',
            value: 'GET'
          },
          {
            label: 'POST',
            value: 'POST'
          },
          {
            label: 'PUT',
            value: 'PUT'
          },
          {
            label: 'DELETE',
            value: 'DELETE'
          }
        ]
      },
      rules: {
        name: [{ required: true, message: '请输入按钮名称', trigger: 'blur' }],
        position: [
          { required: true, message: '请选择按钮类型', trigger: 'blur' }
        ],
        tag: [{ required: true, message: '请输入按钮标识', trigger: 'blur' }],
        style: [{ required: true, message: '请选择PC样式', trigger: 'blur' }],
        fun: [{ required: true, message: '请选择click事件', trigger: 'blur' }]
      },
      showFormatter: false,
      placeholder: `/*
todo函数内提供的可使用的对象说明：      
params: Object|Array scrop?.row;
that: Object 执行todo方法的当前vue实例对象;
winodow: Wnindow对象;
*/  
function todo(){
  your code...
  console.log(params, that, window)
}
// 调用
todo()
`
    }
  },
  watch: {
    show(val) {
      // 通过复制解决v-if实时解析
      this.form = deepClone(this.row)
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    setMethod(fun) {
      // this.form.reqMethod = fun === 'import' ? 'POST' : 'GET'
      switch (fun) {
        case 'import':
          this.form.reqMethod = 'POST'
          this.form.url = ''
          this.form.params = []
          break
        case 'export': {
          let apiId = this.data?.apiId
          let fileName = this.data.option?.title || this.main.data?.reportName
          this.form.url = `/apis/exportExcel/${apiId}`
          this.form.reqMethod = 'POST'
          this.form.params = [
            {
              label: 'fileName',
              value: fileName,
              type: 'query'
            },
            {
              label: 'doDownload',
              value: 'true',
              type: 'query'
            }
          ]
          break
        }
        default:
          this.form.url = ''
          this.form.reqMethod = 'GET'
          this.form.params = []
      }
    },
    addParams() {
      this.form.params = this.form.params.filter((item) => {
        return item.label || item.value
      })
      this.form.params.push({
        label: '',
        value: '',
        type: 'query'
      })
    },
    deleteParams(index) {
      this.form.params.splice(index, 1)
    },
    updateFormatter(val) {
      this.form.formatter = val
    },
    onSubmit() {
      this.$refs.btnForm.validate((bool) => {
        if (bool) {
          this.$emit('change', this.form, this.index)
          this.visible = false
        }
      })
    }
  }
}
</script>
